import { AddressModel } from '@cibo/core'
import { Skeleton, Stack, Typography } from '@mui/material'
import { useFarm } from '../../../queries'

interface FarmProps {
  farmId?: string
}

export const Farm = ({ farmId }: FarmProps) => {
  const farm = useFarm(farmId)

  if (farm.isLoading) {
    return (
      <Skeleton>
        <Typography variant="h5">farm is loading!</Typography>
      </Skeleton>
    )
  }

  if (!farm.data) return null

  const addressModel = new AddressModel(farm.data.address)

  return (
    <Stack spacing={0} data-testid="land_report_farm">
      <Typography variant="body2">{farm.data.name}</Typography>
      {!!farm.data.user && <Typography variant="body2">{farm.data.user.email}</Typography>}
      {!!addressModel.label && <Typography variant="caption">{addressModel.label}</Typography>}
    </Stack>
  )
}
